// @/utils/api/fetchPlaylist.ts
import { objectToParamsQuery } from '@/utils'
import { debug } from '@/utils/debug'
import settings from '@/settings/public'

interface ICookieStore {
  getAll(): { name: string; value: string }[]
}

export const fetchPlaylist = async ({
  id,
  pageParam = 1,
  options,
  cookies: cookieStore,
  forwardHeaders,
}: {
  id: string
  pageParam: number
  options?: { params?: Record<string, any> }
  /** Pass cookies when calling from server to forward the session — otherwise
   *  every SSR prefetch mints a throwaway anonymous session upstream (PRO-946). */
  cookies?: ICookieStore
  /** Server-only: client headers to forward on the loopback fetch (buildSsrForwardHeaders). */
  forwardHeaders?: Record<string, string>
}) => {
  const queryString = objectToParamsQuery(options?.params || {})

  const url = `${settings.api.host}/api/generic/playlists?id=${id}&${
    queryString ? `${queryString}` : 'sortByAsc=order'
  }&page=${pageParam}`

  const cookieHeader = cookieStore
    ? cookieStore.getAll().map(c => `${c.name}=${c.value}`).join('; ')
    : undefined

  const headers: Record<string, string> = { ...forwardHeaders }
  if (cookieHeader) headers['Cookie'] = cookieHeader

  try {
    const response = await fetch(url, { headers })
    if (!response.ok) {
      throw new Error(`Failed to fetch playlist ${id}: ${response.status} ${response.statusText}`)
    }
    const playlistJson = await response.json()
    return playlistJson
  } catch (error: any) {
    debug.error('Error fetching playlist:', error)
    throw new Error(`Playlist fetch failed: ${error.message}`)
  }
}